import { render, staticRenderFns } from "./valueSetModal.vue?vue&type=template&id=2406bd27"
import script from "./valueSetModal.vue?vue&type=script&lang=js"
export * from "./valueSetModal.vue?vue&type=script&lang=js"
import style0 from "./valueSetModal.vue?vue&type=style&index=0&id=2406bd27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports